<template>
  <div v-if="commentsEnabled || filesEnabled" class="my-1">
    <div v-if="commentsEnabled" class="mb-1">
      <label :for="`input-${action.id}`">
        {{ $t("action_plan.viewer.comments") }}
      </label>
      <input
        :id="`input-${action.id}`"
        v-model="action.data.comments"
        type="text"
        class="form-control"
        :placeholder="$t('action_plan.viewer.comments')"
        :disabled="terminated || validating"
        @change="$emit('checkpoint')"
      />
    </div>
    <files
      v-if="filesEnabled"
      v-model="action.data.files"
      :action-plan-log-uuid="actionPlanLogUuid"
      :validating="validating"
      :preview="preview"
      :terminated="terminated"
      :action="action"
      @files-changed="$emit('checkpoint')"
    />
  </div>
</template>

<script>
import Files from "./Files.vue";

export default {
  name: "ActionPlanNodeExtras",
  components: { Files },
  props: {
    actionPlanLogUuid: String,
    action: {
      type: Object,
      required: true,
    },
    viewerOptions: {
      type: Object,
      default: () => ({}),
    },
    terminated: Boolean,
    preview: Boolean,
    validating: Boolean,
  },
  computed: {
    commentsEnabled() {
      return this.viewerOptions.comments_enabled === true;
    },
    filesEnabled() {
      return this.viewerOptions.files_enabled === true;
    },
  },
};
</script>
